(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('TransportTypeDialogController', TransportTypeDialogController);

    TransportTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'TransportType'];

    function TransportTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, TransportType) {
        var vm = this;

        vm.transportType = entity;
       /* vm.transportType1 = [{code:'T01',type:'BK', description:'Bưu Kiện',status:'1'},
                            {code:'T02',type:'EMS', description:'Chuyển Phát Nhanh',status:'1'},
                            {code:'T03',type:'UT', description:'Ủy Thác',status:'1'},
                            {code:'T04',type:'DS', description:'Đường Sắt',status:'1'},
                            {code:'T05',type:'NB', description:'Công ty xe, messenger',status:'1'},
                            {code:'T06',type:'NV', description:'Nhân viên đến giao/nhận',status:'1'}];
        vm.transportType = vm.transportType1[0];*/
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
        if (vm.transportType.transportTypeId != null || vm.transportType.transportTypeId != undefined) {
       	 vm.checkcreat = true;
       	vm.transportType.isExit = true;
       }else{
    	   vm.transportType.isExit = false;
    	   vm.transportType.status = "0";
       }
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if (vm.transportType.isExit == true) {
            	
            	TransportType.update(vm.transportType,function(result){
          		  $scope.$emit('masterApp:transportTypeUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
        	},function(error) {
        		vm.isSaving = false;
		});
            } else {
            	TransportType.save(vm.transportType,function(result){
        		  $scope.$emit('masterApp:transportTypeUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
    		});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:transportTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



    }
})();
